import { render, staticRenderFns } from "./ScheduleSuggestionForm.vue?vue&type=template&id=19880080&"
import script from "./ScheduleSuggestionForm.vue?vue&type=script&lang=js&"
export * from "./ScheduleSuggestionForm.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleSuggestionForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports